module.exports = __webpack_public_path__ + "static/media/bg10.3be5ab88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/editor/layout/addons/props/components/bgTheme/bg/bg10.jpg
// module id = 3321
// module chunks = 0